import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddCreditNote() {
  const [amount, setAmount] = useState('');
  const [issueDate, setIssueDate] = useState(new Date().toISOString().split('T')[0]);
  const [userRole, setUserRole] = useState(""); // State to store user role
  const [userName, setUserName] = useState(""); // State to store user name
  const [organizations, setOrganizations] = useState([]); // List of organizations for Main Admin
  const [currentUser, setCurrentUser] = useState("");
  const [locations, setLocations] = useState([]);
  const [customers, setCustomers] = useState([]);
  const[selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedCustomerName, setSelectedCustomerName] = useState(null); // Stores customer name
  const [invoices, setInvoices] = useState(null); // State to store invoices related to the selected customer
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoiceSearchQuery, setInvoiceSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [reason, setReason] = useState('');
  const invoicesPerPage = 8;

  useEffect (() => {
    const fetchUserRoleAndOrganizations = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }

        // Fetch user role
        const userResponse = await axios.get(`${API_BASE_URL}/users/specific`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserRole(userResponse.data.role);
        setCurrentUser(userResponse.data);
        setUserName(userResponse.data.username); 

        // Fetch organizations if the user is a Main Admin
        if (userResponse.data.role === "Main Admin") {
          const orgResponse = await axios.get(`${API_BASE_URL}/organizations`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setOrganizations(orgResponse.data.organizations || []);
        }
      } catch (error) {
        console.error("Error fetching user role or organizations:", error);
        toast.error("Error fetching data");
      }
    };

    const fetchCurrentUser = async () => {
      const token = localStorage.getItem("token");
          if (!token) {
              toast.error("Authentication token missing. Please log in.");
              return;
          }
          try {
              const response = await axios.get(
                  `${API_BASE_URL}/users/specific`,
                  {
                  headers: { Authorization: `Bearer ${token}` },
                  }
          );
          const userData = response.data;
          setCurrentUser(userData);
          // Fetch locations and products based on role
          if (userData.role === "Main Admin") {
              fetchAllLocations();
          } else if (userData.role === "Company Admin") {
              fetchFilteredLocations(userData);
          }
          } catch (error) {
              console.error("Error fetching user data:", error);
              toast.error("Failed to fetch user data.");
          }
  
          fetchCurrentUser();
    };

    const fetchAllLocations = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
          `${API_BASE_URL}/locations`,
          {
              headers: { Authorization: `Bearer ${token}` },
          }
      );
      setLocations(response.data.locations);
      };

      const fetchFilteredLocations = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
          `${API_BASE_URL}/products/filtered-locations`,
          {
          headers: { Authorization: `Bearer ${token}` },
          }
      );
      setLocations(response.data.locations);
  };

  const fetchCustomers = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/customers/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );


    setCustomers(response.data.customers);
  };

    fetchUserRoleAndOrganizations();  
    fetchCustomers();
  }, [userRole]);

  // const getInvoices = async () => { 
  
  //     if (!selectedCustomer) {
  //       setInvoices(null); // No customer selected
  //       return;
  //     }
  
  //     try {
  //       const token = localStorage.getItem('token');
  //       if (!token) {
  //         toast.error('Authentication token is missing. Please log in again.');
  //         return;
  //       }
  //       const response = await axios.get(`${API_BASE_URL}/invoices/get/getUnsettledInvoiceByCustomer/${selectedCustomer}`, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  
  //       if (response.status === 200 && response.data.length > 0) {
  //           setInvoices(response.data);
  //       } else {
  //         setInvoices(null); // No invoices or empty invoices
  //       }
  
  //       console.log('Invoices:', response.data);
        
  //     } catch (error) {
  //       if (error.response && error.response.status === 404) {
  //         setInvoices(null); // Handle no invoices found
  //         toast.info('No invoices found for this customer.');
  //       } else {
  //         toast.error('Error fetching invoices');
  //       }
  //       console.error('Error fetching invoices:', error.response || error);
  //     }
  //   };

  // useEffect(() => {
  //   if (selectedCustomer) {
  //       getInvoices();
  //   }
  //   }, [selectedCustomer]);

    const handleAddCreditNote = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            toast.error("Authentication token is missing. Please log in again.");
            return;
        }

        if (!selectedCustomer || !amount || !issueDate || !reason) {
            toast.error("Please fill in all required fields.");
            return;
        }

        // if(!selectedInvoice) {
        //   toast.error("Please select an invoice to apply the credit note.");
        //   return;
        // }

        // if (selectedInvoice) {
        //   const invoice = invoices.find(inv => inv._id === selectedInvoice);
        //   if (!invoice) {
        //     toast.error("Selected invoice not found.");
        //     return;
        //   }
        //   if (Number(amount) > invoice.blance) {
        //     toast.error("Credited amount cannot be greater than the Invoice Balance.");
        //     return;
        //   }
        //   if (Number(amount) <= 0) {
        //     toast.error("Credited amount must be greater than zero.");
        //     return;
        //   }
        // }

        try {
            const payload = {
            issueDate: issueDate,
            customer_id: selectedCustomer,
            reason: reason,
            created_by: currentUser._id, // currentUser contains the logged-in user's data
            amount: Number(amount),
            invoices: selectedInvoice ? [{
                invoice_id: selectedInvoice,
                credit_applied: Number(amount), // You can enhance this to allow partial amounts
            }] : [],
            };

            const response = await axios.post(
                `${API_BASE_URL}/creditNotes/add`,
                payload,
                {
                    headers: {
                    Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 201) {
            toast.success("Credit note added successfully!");
            // Optionally reset form fields
            setAmount('');
            setSelectedCustomer(null);
            setSelectedCustomerName(null);
            setSelectedInvoice(null);
            setReason('');
            }
        } catch (error) {
            console.error("Error adding credit note:", error);
            toast.error(error.response?.data?.message || "Failed to add credit note.");
        }
    };

//  const toggleInvoiceSelection = (invoiceId) => {
//   setSelectedInvoice((prevSelected) =>
//     prevSelected === invoiceId ? null : invoiceId
//   );
// };

//     const filteredInvoices = invoices?.filter((invoice) => {
//         const searchTerm = invoiceSearchQuery.toLowerCase();
//         return (
//             invoice.invoice_id.toLowerCase().includes(searchTerm) ||
//             (invoice.amount?.toString().includes(searchTerm)) ||
//             (invoice.blance?.toString().includes(searchTerm))
//         );
//     });

  const customCustomerIDSelect = (customerOptions, selectedCustomer, setSelectedCustomer, setSelectedCustomerName) => {
    return (
      <Select
        options={customerOptions}
        getOptionLabel={(e) => e.customer_code} // Show customer ID in dropdown
        getOptionValue={(e) => e._id} // Use _id as value
        isSearchable={true} // Enable search functionality
        placeholder="Search by Customer ID"
        className="w-full"
        value={customerOptions.find((option) => option._id === selectedCustomer) || null}
        onChange={(selectedOption) => {
          setSelectedCustomer(selectedOption?._id); // Set selected customer ID
          setSelectedCustomerName(selectedOption?.customer_name); // Auto-fill the customer name
        }}
      />
    );
  };
  
  const customCustomerNameSelect = (customerOptions, selectedCustomerName, setSelectedCustomerName, setSelectedCustomer) => {
    return (
      <Select
        options={customerOptions}
        getOptionLabel={(e) => e.customer_name} // Show customer name in dropdown
        getOptionValue={(e) => e._id} // Use _id as value
        isSearchable={true} // Enable search functionality
        placeholder="Search by Customer Name"
        className="w-full"
        value={customerOptions.find((option) => option.customer_name === selectedCustomerName) || null}
        onChange={(selectedOption) => {
          setSelectedCustomer(selectedOption?._id); // Auto-fill customer ID
          setSelectedCustomerName(selectedOption?.customer_name); // Set selected customer name
        }}
      />
    );
  }

    // const indexOfLastInvoice = currentPage * invoicesPerPage;
    // const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
    // const currentInvoices = filteredInvoices?.slice(indexOfFirstInvoice, indexOfLastInvoice);

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <h2 className="text-2xl font-bold text-green-700 mb-6">
          Add Credit Note
        </h2>
        <div className="grid grid-cols-2 gap-6 mb-6">
        <div>
            <label className="block text-gray-700 mb-2">Customer ID</label>
            {customCustomerIDSelect(customers, selectedCustomer, setSelectedCustomer, setSelectedCustomerName)}
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Customer</label>
            {customCustomerNameSelect(customers, selectedCustomerName, setSelectedCustomerName, setSelectedCustomer)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6 mb-6">
        
          <div>
              <label className="block text-gray-700 mb-2">Amount Credited (LKR)</label>
              <input
                type="number"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter payment amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Issue Date</label>
            <input
              type="date"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={issueDate}
              onChange={(e) => setIssueDate(e.target.value)}
            />
          </div>
        </div>
        <div className="grid grid-cols- gap-6 mb-6">
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Reason</label>
            <textarea
              className="w-full p-3 border rounded-lg"
              rows="6"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for credit note ......"
            ></textarea>
          </div>
        </div>
        <div className="flex justify-end mt-6">
          <button
            className="bg-green-700 text-white px-6 py-3 rounded-lg hover:bg-blue-600"
            onClick={handleAddCreditNote}
          >
            Add Credit Note
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddCreditNote;
    

// {invoices && (
//             <div className="mb-2 border rounded-lg p-3 bg-gray-50">
//              <label className='block text-gray-700'>Invoices</label>
//                 <div className="mt-4 mb-2">
//                     <input
//                     type="text"
//                     className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     placeholder="Search invoices by ID"
//                     value={invoiceSearchQuery}
//                     onChange={(e) => setInvoiceSearchQuery(e.target.value)}
//                     />
//                 </div>
//                     <table className="table-auto w-full mt-4 border border-gray-200">
//                         <thead className="bg-gray-100">
//                         <tr>
//                             <th className="border px-4 py-2 text-left">Invoice ID</th>
//                             <th className="border px-4 py-2 text-right">Sales Order ID</th>
//                             <th className="border px-4 py-2 text-right">Amount (LKR)</th>
//                             {/* <th className="border px-4 py-2 text-right">Balance (LKR)</th> */}
//                             <th className="border px-4 py-2 text-center">Action</th>
//                         </tr>
//                         </thead>
//                         <tbody>
//                             {currentInvoices.map((invoice) => (
//                                 <tr key={invoice._id} className="hover:bg-gray-50">
//                                     <td className="border px-4 py-2">{invoice.invoice_id}</td>
//                                     <td className="border px-4 py-2 text-right">{invoice.sales_order_id?.sales_order_id|| '—'}</td>
//                                     <td className="border px-4 py-2 text-right">{typeof invoice.amount === 'number' ? invoice.amount.toFixed(2) : '—'}</td>
//                                     {/* <td className="border px-4 py-2 text-right">{typeof invoice.blance === 'number' ? invoice.blance.toFixed(2) : '—'}</td> */}
//                                     <td className="border px-4 py-2 text-center">
//                                     <button
//                                         onClick={() => toggleInvoiceSelection(invoice._id)}
//                                         className={`px-3 py-1 rounded text-white ${
//                                         selectedInvoice === invoice._id
//                                             ? 'bg-red-500 hover:bg-red-600'
//                                             : 'bg-green-500 hover:bg-green-600'
//                                         }`}
//                                     >
//                                         {selectedInvoice === invoice._id ? 'Unselect' : 'Select'}
//                                     </button>
//                                     </td>
//                                 </tr>
//                                 ))}
//                             </tbody>
//                     </table>
//                     {filteredInvoices && filteredInvoices.length > invoicesPerPage && (
//                         <div className="flex justify-center mt-4 space-x-2">
//                             <button
//                             className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
//                             onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                             disabled={currentPage === 1}
//                             >
//                             Prev
//                             </button>
//                             <span className="px-4 py-1 text-gray-700">
//                             Page {currentPage} of {Math.ceil(filteredInvoices.length / invoicesPerPage)}
//                             </span>
//                             <button
//                             className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
//                             onClick={() =>
//                                 setCurrentPage((prev) =>
//                                 Math.min(prev + 1, Math.ceil(filteredInvoices.length / invoicesPerPage))
//                                 )
//                             }
//                             disabled={currentPage === Math.ceil(filteredInvoices.length / invoicesPerPage)}
//                             >
//                             Next
//                             </button>
//                         </div>
//                         )}

//                 </div>
//                 )}